<template>
  <div class="sf">
    <div class="sf-grid">
      <label class="sf-field">
        <span class="sf-label">Проект</span>
        <input class="btn" :list="lid + 'Project'" v-model="projectName" @change="onProject" placeholder="Проект">
        <datalist :id="lid + 'Project'">
          <option v-for="p in projects" :key="p.id" :value="p.name"></option>
        </datalist>
      </label>

      <label class="sf-field">
        <span class="sf-label">Токен</span>
        <input class="btn" :list="lid + 'Token'" v-model="tokenName" @change="onToken" placeholder="Сайт или страница">
        <datalist :id="lid + 'Token'">
          <option v-for="t in tokens" :key="t.token" :value="t.name + ' | ' + t.site"></option>
        </datalist>
      </label>

      <label class="sf-field">
        <span class="sf-label">UTM группа</span>
        <input class="btn" :list="lid + 'Utm'" v-model="utmName" @change="onUtmGroup" placeholder="Группа утм">
        <datalist :id="lid + 'Utm'">
          <option v-for="g in utmGroups" :key="g.id" :value="g.name"></option>
        </datalist>
      </label>

      <label class="sf-field">
        <span class="sf-label">Период изменения</span>
        <select class="btn" v-model="datePointIndex" @change="onDatePoint">
          <option value="">Выберите период</option>
          <option v-for="(dp, i) in datePoints" :key="i" :value="i">{{ dp[0] }} — {{ dp[1] }}</option>
        </select>
      </label>

      <label class="sf-field">
        <span class="sf-label">Начало периода</span>
        <input class="btn" type="date" v-model="dateStart" @change="onDateStart">
      </label>

      <label class="sf-field">
        <span class="sf-label">Конец периода</span>
        <input class="btn" type="date" v-model="dateEnd" @change="onDateEnd">
      </label>

      <label class="sf-field">
        <span class="sf-label">Мин. сессий со словом</span>
        <input class="btn" type="number" min="0" v-model="minSessions" placeholder="0">
      </label>

      <div class="sf-field sf-submit">
        <button class="btn sf-go" @click="apply">Запросить</button>
      </div>
    </div>

    <div v-if="conversions" class="sf-cards">
      <div class="sf-card">
        <div class="sf-card-label">Микроконверсий</div>
        <div class="sf-card-value num">{{ conversions.conversionMicro }}</div>
      </div>
      <div class="sf-card">
        <div class="sf-card-label">Формы</div>
        <div class="sf-card-value num">{{ conversions.conversionForm }}</div>
      </div>
      <div class="sf-card">
        <div class="sf-card-label">Всего конверсий</div>
        <div class="sf-card-value num">{{ conversions.conversionAll }}</div>
      </div>
      <div class="sf-card">
        <div class="sf-card-label">Сессий с рекламы</div>
        <div class="sf-card-value num">{{ conversions.sessionCount }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchProjects, fetchTokens, fetchDatePoints, fetchUtmGroups } from '@/utils/statFilters';

// Счётчик экземпляров: datalist браузер ищет по id глобально, и две шапки
// на одной странице делили бы один список вариантов.
let uid = 0;

// Выбор фильтров общий для «Отчёта по блокам» и «Инсайтов»: шапка одна и та же,
// и переход между дашбордами не должен заставлять выбирать всё заново.
const PREFS_KEY = 'statFilters';

function readPrefs() {
  try {
    const raw = localStorage.getItem(PREFS_KEY);
    const parsed = raw ? JSON.parse(raw) : null;
    // Ключ мог остаться от чужой версии или быть испорчен вручную.
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch (e) {
    return {};
  }
}

export default {
  name: 'StatFilters',
  props: {
    conversions: { type: Object, default: null },
  },
  emits: ['apply', 'min-sessions'],
  data() {
    uid += 1;
    return {
      lid: 'sf' + uid,
      projects: [],
      tokens: [],
      utmGroups: [],
      datePoints: [],
      projectId: '',
      projectName: '',
      token: '',
      tokenName: '',
      utmGroupId: '',
      utmName: '',
      datePointIndex: '',
      dateStart: '',
      dateEnd: '',
      dateTimeStart: '',
      dateTimeEnd: '',
      minSessions: '',
    };
  },
  computed: {
    // Снимок выбора, который переживает перезагрузку и переход между дашбордами.
    prefs() {
      return {
        projectId: this.projectId, projectName: this.projectName,
        token: this.token, tokenName: this.tokenName,
        utmGroupId: this.utmGroupId, utmName: this.utmName,
        datePointIndex: this.datePointIndex,
        dateStart: this.dateStart, dateEnd: this.dateEnd,
        // Точки периода несут время, а не только дату: пересчёт из dateStart
        // его потерял бы и сдвинул границу выборки на начало суток.
        dateTimeStart: this.dateTimeStart, dateTimeEnd: this.dateTimeEnd,
        minSessions: this.minSessions,
      };
    },
  },
  watch: {
    minSessions(value) {
      this.$emit('min-sessions', value);
    },
    prefs(value) {
      try {
        localStorage.setItem(PREFS_KEY, JSON.stringify(value));
      } catch (e) {
        // Приватный режим или переполнение — фильтры просто не запомнятся.
      }
    },
  },
  mounted() {
    const saved = readPrefs();
    this.dateStart = saved.dateStart || '';
    this.dateTimeStart = saved.dateTimeStart || '';
    this.dateEnd = saved.dateEnd || new Date().toISOString().substr(0, 10);
    this.dateTimeEnd = saved.dateTimeEnd || new Date().toISOString();
    this.minSessions = saved.minSessions || '';
    this.loadProjects(saved);
  },
  methods: {
    clientId() {
      return localStorage.getItem('clientId');
    },
    loadProjects(saved) {
      fetchProjects(this.clientId())
        .then(list => {
          this.projects = list;
          // projectCurrent пишут и другие страницы («Токены», «Группы UTM»,
          // «Блоки и события»), поэтому он остаётся отдельным ключом и имеет
          // приоритет: пользователь мог сменить проект там.
          const id = localStorage.getItem('projectCurrent') || saved.projectId;
          if (!id || !list.some(p => p.id === id)) return;
          this.projectId = id;
          this.projectName = localStorage.getItem('projectCurrentName')
            || (list.find(p => p.id === id) || {}).name || '';
          this.loadTokens(id === saved.projectId ? saved : {});
        })
        .catch(err => console.log(err));
    },
    loadTokens(saved) {
      fetchTokens(this.clientId(), this.projectId)
        .then(list => {
          this.tokens = list;
          const chosen = saved && saved.token
            ? list.find(t => t.token === saved.token) : null;
          if (!chosen) return;
          this.token = chosen.token;
          this.tokenName = chosen.name + ' | ' + chosen.site;
          this.loadTokenRefs(saved);
        })
        .catch(err => console.log(err));
    },
    // Справочники, зависящие от токена. Отдельным методом, потому что нужны
    // и при восстановлении, и при ручном выборе токена.
    loadTokenRefs(saved) {
      fetchDatePoints(this.clientId(), this.projectId, this.token)
        .then(list => {
          this.datePoints = list;
          // Индекс точки восстанавливаем, только если она осталась той же:
          // за время отсутствия могли добавиться новые точки и сдвинуть нумерацию.
          const i = saved && saved.datePointIndex;
          if (i !== '' && i !== undefined && list[i] && list[i][0] === saved.dateTimeStart) {
            this.datePointIndex = i;
          }
        })
        .catch(err => console.log(err));
      fetchUtmGroups(this.clientId(), this.projectId)
        .then(list => {
          this.utmGroups = list;
          const group = saved && saved.utmGroupId
            ? list.find(g => g.id === saved.utmGroupId) : null;
          if (!group) return;
          this.utmGroupId = group.id;
          this.utmName = group.name;
        })
        .catch(err => console.log(err));
    },
    // Старая шапка в BlockStat при вводе, не совпавшем со справочником, молча
    // оставляла прежний выбор: поле показывало одно, «Запросить» отправляло
    // другое. Здесь выбор обнуляется — расхождение с исходным поведением
    // намеренное.
    onProject() {
      const selected = this.projects.find(p => p.name === this.projectName);
      this.projectId = selected ? selected.id : '';
      // Токен, группа и периоды принадлежали прежнему проекту.
      this.tokens = [];
      this.token = '';
      this.tokenName = '';
      this.utmGroups = [];
      this.utmGroupId = '';
      this.utmName = '';
      this.datePoints = [];
      this.datePointIndex = '';
      if (!selected) return;
      localStorage.setItem('projectCurrent', selected.id);
      localStorage.setItem('projectCurrentName', selected.name);
      this.loadTokens({});
    },
    onToken() {
      const selected = this.tokens.find(t => t.name + ' | ' + t.site === this.tokenName);
      this.token = selected ? selected.token : '';
      this.datePoints = [];
      this.datePointIndex = '';
      if (!selected) return;
      this.loadTokenRefs({});
    },
    onUtmGroup() {
      const selected = this.utmGroups.find(g => g.name === this.utmName);
      this.utmGroupId = selected ? selected.id : '';
    },
    onDatePoint() {
      const pair = this.datePoints[this.datePointIndex];
      if (!pair) return;
      this.dateStart = pair[0].split('T')[0];
      this.dateTimeStart = pair[0];
      if (pair[1] !== 'сегодня') {
        this.dateEnd = pair[1].split('T')[0];
        this.dateTimeEnd = pair[1];
      } else {
        this.dateEnd = new Date().toISOString().substr(0, 10);
        this.dateTimeEnd = new Date().toISOString();
      }
    },
    onDateStart() {
      this.dateTimeStart = this.dateStart ? new Date(this.dateStart).toISOString() : '';
      this.datePointIndex = '';
    },
    onDateEnd() {
      this.dateTimeEnd = this.dateEnd ? new Date(this.dateEnd).toISOString() : '';
      this.datePointIndex = '';
    },
    apply() {
      this.$emit('apply', {
        token: this.token,
        utmGroupId: this.utmGroupId,
        dateStart: this.dateTimeStart,
        dateEnd: this.dateTimeEnd,
      });
    },
  },
};
</script>

<style scoped>
.sf { margin-bottom: 18px; }
.sf-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
  gap: 10px 14px;
  align-items: end;
}
.sf-field { display: flex; flex-direction: column; gap: 4px; min-width: 0; }
.sf-label { font-size: 11.5px; color: var(--text-muted); }
.sf-field :deep(input), .sf-field :deep(select) { width: 100%; }
.sf-submit { justify-content: flex-end; }
.sf-go { background: var(--accent); border-color: var(--accent); color: #fff; font-weight: 600; }
.sf-go:hover { border-color: var(--accent); filter: brightness(1.08); }
.sf-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 10px;
  margin-top: 16px;
}
.sf-card {
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 12px 14px;
  background: var(--surface-1);
}
.sf-card-label { font-size: 11.5px; color: var(--text-muted); }
.sf-card-value { font-size: 22px; font-weight: 700; margin-top: 2px; }
</style>
